import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { apolloClient } from "../../constants/apolloClient";
import { LibraryV1GetMultipleFeatureFlagsDocument } from "./graphql/GetMultipleFeatureFlags.v5.generated";
/**
 * Fetch multiple V5 feature flags in a single GraphQL request.
 * Returns one TFetchFlagReturnType per requested flag key.
 */
export function fetchV5FeatureFlagsBatch(_x) {
  return _fetchV5FeatureFlagsBatch.apply(this, arguments);
}
function _fetchV5FeatureFlagsBatch() {
  _fetchV5FeatureFlagsBatch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var flagKeys, organizationId, _data$features_flags, _yield$apolloClient$q, data, error, result, _result$errors$join, _result$errors, errorMessage, flagMap, _iterator, _step, ff;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          flagKeys = _ref.flagKeys, organizationId = _ref.organizationId;
          _context.prev = 1;
          _context.next = 4;
          return apolloClient.query({
            query: LibraryV1GetMultipleFeatureFlagsDocument,
            fetchPolicy: 'cache-first',
            variables: {
              input: {
                name_keys: flagKeys,
                organization_id: String(organizationId)
              }
            },
            context: {
              clientName: 'v5'
            }
          });
        case 4:
          _yield$apolloClient$q = _context.sent;
          data = _yield$apolloClient$q.data;
          error = _yield$apolloClient$q.error;
          if (!error) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: error
            };
          }));
        case 9:
          result = data === null || data === void 0 ? void 0 : (_data$features_flags = data.features_flags) === null || _data$features_flags === void 0 ? void 0 : _data$features_flags.get_feature_flags; // Handle error union types
          if (!((result === null || result === void 0 ? void 0 : result.__typename) === 'QueryValidationError' || (result === null || result === void 0 ? void 0 : result.__typename) === 'QueryInternalError')) {
            _context.next = 13;
            break;
          }
          errorMessage = (_result$errors$join = (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.join(', ')) !== null && _result$errors$join !== void 0 ? _result$errors$join : 'Unknown error';
          return _context.abrupt("return", flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: new Error(errorMessage)
            };
          }));
        case 13:
          // Success — build a map for fast lookup
          flagMap = new Map();
          if ((result === null || result === void 0 ? void 0 : result.__typename) === 'GetFeatureFlagsPayload') {
            _iterator = _createForOfIteratorHelper(result.feature_flags);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                ff = _step.value;
                flagMap.set(ff.name_key, Boolean(ff.value));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          // Return one result per requested key (flags not found default to false)
          return _context.abrupt("return", flagKeys.map(function (flagKey) {
            var _flagMap$get;
            return {
              flagKey: flagKey,
              flagValue: (_flagMap$get = flagMap.get(flagKey)) !== null && _flagMap$get !== void 0 ? _flagMap$get : false,
              apiVersion: 'V5'
            };
          }));
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          console.error('Error fetching feature flags batch', _context.t0);
          return _context.abrupt("return", flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: _context.t0
            };
          }));
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _fetchV5FeatureFlagsBatch.apply(this, arguments);
}